<script setup lang="ts">
import { Button } from '@/components/ui/button'

/** The action row at the bottom of a mobile feed card: the main button, favorite and the menu. */
defineProps<{
  /** Without a label there is no main button (the viewer cannot act on this card). */
  primaryLabel?: string
  primaryDisabled?: boolean
  favoriteActive?: boolean
}>()

const emit = defineEmits<{ action: ['primary' | 'favorite' | 'more'] }>()

const iconAction = 'flex h-12 min-w-14 flex-col items-center gap-0 rounded-full p-1 text-[0.625rem] font-normal leading-none text-white hover:bg-transparent hover:text-white active:bg-transparent active:text-white'
</script>

<template>
  <div class="flex items-center gap-3">
    <Button
      v-if="primaryLabel"
      type="button"
      class="h-12 flex-1 rounded-full text-base font-normal"
      :disabled="primaryDisabled"
      @click="emit('action', 'primary')"
    >
      {{ primaryLabel }}
    </Button>
    <Button
      type="button"
      variant="ghost"
      :class="iconAction"
      :aria-label="favoriteActive ? 'Убрать из избранного' : 'Добавить в избранное'"
      :aria-pressed="favoriteActive"
      @click="emit('action', 'favorite')"
    >
      <Icon
        name="tabler:heart-filled"
        class="size-7"
        :class="favoriteActive && 'text-destructive'"
        aria-hidden="true"
      />
      <span>Избранное</span>
    </Button>
    <Button
      type="button"
      variant="ghost"
      size="icon"
      :class="iconAction"
      aria-label="Дополнительные действия"
      @click="emit('action', 'more')"
    >
      <Icon
        name="tabler:dots-vertical"
        class="size-5"
        aria-hidden="true"
      />
    </Button>
  </div>
</template>
